import { PollPinSettingsEmoji } from '@lessonup/pins-shared';
import { SpaceBetween, spacing, styled } from '@lessonup/ui-components';
import React from 'react';
import { PollEmojiButton } from '../../../../../components/PollEmojiButton';

export interface EmojiPollAnswerAreaContentProps {
  pinSettings: Pick<PollPinSettingsEmoji, 'answers'>;
  isInteractive?: boolean;
  selectedAnswerId?: string;
  onAnswerClick?: (answerId: string) => void;
}

export function EmojiPollAnswerAreaContent({
  pinSettings: { answers },
  isInteractive = false,
  selectedAnswerId,
  onAnswerClick,
}: EmojiPollAnswerAreaContentProps) {
  return (
    <StyledAnswerAreaContentWrapper direction="x" spacing={spacing.size8} justifyContent="center">
      {answers.map((answer, id) => {
        return (
          <PollEmojiButton
            key={id}
            emoji={answer.text}
            size="large"
            onClick={onAnswerClick ? () => onAnswerClick(answer.id) : undefined}
            selected={selectedAnswerId === answer.id}
            as={isInteractive || onAnswerClick ? undefined : 'div'}
          />
        );
      })}
    </StyledAnswerAreaContentWrapper>
  );
}

const StyledAnswerAreaContentWrapper = styled(SpaceBetween)`
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
